module.exports = __webpack_public_path__ + "img/arrow-share.8b662403.png";